import useReactHookForm from "hooks/useReactHookForm";

import { useAppDispatch } from "hooks/redux";
import { Button, Grid, Paper } from "@mui/material";
import DynamicForm from "shared/organisms/dynamicform";
import ContentRight from "shared/molecules/content-right";
import {
  courseClassSubChapMapFilterInitialValues,
  courseClassSubChapMapFilterProperties,
  courseClassSubChapMapFilterValidationSchema,
} from "./helper";
import { isEmpty } from "utils/helpers";
import { useEffect } from "react";
import { hasValidValue } from "pages/entities/helper";

export const CscMappingFilter = ({
  setSearchPayload,
  setPage,
  clearValuesTrigger,
}) => {
  const { control, errors, getValues, watch, setValue } = useReactHookForm(
    courseClassSubChapMapFilterInitialValues,
    courseClassSubChapMapFilterValidationSchema,
    ""
  );

  const clearFilter = () => {
    setValue("global_course_id", "");
    setValue("global_subject_id", "");
    setValue("global_chapter_id", "");
    setValue("class_id", "");
    setValue("status", "");
    setSearchPayload({});
    setPage(1);
  };
  const handleSearch = () => {
    const payload = {
    };
     if (!isEmpty(watch()?.global_course_id)) {
      payload["global_course_id"] = watch()?.global_course_id;
    }
    if (!isEmpty(watch()?.global_subject_id)) {
      payload["global_subject_id"] = watch()?.global_subject_id;
    }
    if (!isEmpty(watch()?.global_chapter_id)) {
      payload["global_chapter_id"] = watch()?.global_chapter_id;
    }
    if (!isEmpty(watch()?.class_id)) {
      payload["class_id"] = watch()?.class_id;
    }
    if (!isEmpty(watch()?.status)) {
      payload["status"] = watch()?.status;
    }
    setSearchPayload(payload);
    setPage(1);
  };
  useEffect(() => {
    clearFilter();
  }, [clearValuesTrigger]);

  return (
    <div>
      <Paper elevation={2} sx={{ px: 2, pb: 2 }}>
        <Grid container spacing={2}>
          <DynamicForm
            fields={courseClassSubChapMapFilterProperties}
            control={control}
            errors={errors}
            getValues={getValues}
            setValue={setValue}
            watch={watch}
          />
          <ContentRight sx={{ mt: -7 }}>
            <Button
              variant="contained"
              sx={{
                width: "70px",
                height: "40px",
                marginTop: "15px",
                marginRight: "10px",
                padding: "7px 42.5px 7px 48.5px",
                cursor: "pointer",
                textAlign: "center",
              }}
              onClick={clearFilter}
              disabled={!hasValidValue(watch(),"")} 
            >
              clear
            </Button>
            <Button
              variant="contained"
              sx={{
                width: "80px",
                height: "40px",
                marginTop: "15px",
                padding: "7px 42.5px 7px 48.5px",
                cursor: "pointer",
                textAlign: "center",
              }}
              onClick={handleSearch}
              disabled={!hasValidValue(watch(),"")} 
            >
              search
            </Button>
          </ContentRight>
        </Grid>
      </Paper>
    </div>
  );
};
